import { VIKRAM_SAMVAT_MONTHS } from "helper/constant";
import * as Yup from "yup";

const validTithiValues = [
  "1", "2", "3", "4", "5", "6", "7", "8", "9", "10",
  "11", "12", "13", "14", "15", "30",
];


const panchangDaySchema = Yup.object().shape({
  gregorianDate: Yup.string()
    .required("Gregorian date is required.")
    .typeError("Gregorian date must be a valid date."),
  vikramSamvatMonth: Yup.string()
    .required("Vikram Samvat month is required.")
    .oneOf(VIKRAM_SAMVAT_MONTHS, "Invalid Vikram Samvat month."),
  tithi: Yup.array().required("Tithi is required.")
    .min(1, "At least one Tithi must be selected.")
    .max(2, "Maximum two Tithis can be selected.").typeError("Select at least one Tithi."),
  // tithiNo: Yup.string().test(
  //   "is-valid-value",
  //   "Invalid value. Must be a digit from 1,2,...,15,30 or a valid range like 1-2, 10-11.",
  //   (value) => {
  //     if (!value) return false;

  //     // Check if it's a single valid digit
  //     if (validTithiValues.includes(value)) {
  //       return true;
  //     }

  //     // Check if it's a valid range
  //     const rangeMatch = value.match(/^(\d+)-(\d+)$/);
  //     if (rangeMatch) {
  //       const [_, start, end] = rangeMatch;
  //       return (
  //         validTithiValues.includes(start) && validTithiValues.includes(end)
  //       );
  //     }

  //     return false;
  //   }
  // ),
  paksha: Yup.string()
    .required("Paksha is required.")
    .oneOf(
      ["Shukla", "Krishna"],
      "Paksha must be either 'Shukla' or 'Krishna'."
    ),

  vachanamrutTithi: Yup.object().shape({
    english: Yup.string()
      .optional()
      .max(
        400,
        "Vachanamrut Tithi description must not exceed 400 characters."
      ),
    gujarati: Yup.string()
      .optional()
      .max(
        400,
        "Vachanamrut Tithi description must not exceed 400 characters."
      ),
    hindi: Yup.string()
      .optional()
      .max(
        400,
        "Vachanamrut Tithi description must not exceed 400 characters."
      ),
  }),

  swaminarayanSamvat: Yup.object().shape({
    english: Yup.string()
      .optional()
      .max(50, "Swaminarayan Samvat must not exceed 50 characters."),
    gujarati: Yup.string()
      .optional()
      .max(50, "Swaminarayan Samvat must not exceed 50 characters."),
    hindi: Yup.string()
      .optional()
      .max(50, "Swaminarayan Samvat must not exceed 50 characters."),
  }),

  dateViseVachanamrut: Yup.object().shape({
    english: Yup.string()
      .optional()
      .max(
        400,
        "Date Vise Vachanamrut Tithi description must not exceed 400 characters."
      ),
    gujarati: Yup.string()
      .optional()
      .max(
        400,
        "Date Vise Vachanamrut Tithi description must not exceed 400 characters."
      ),
    hindi: Yup.string()
      .optional()
      .max(
        400,
        "Date Vise Vachanamrut Tithi description must not exceed 400 characters."
      ),
  }),

  event: Yup.object().shape({
    english: Yup.string().optional(),
    gujarati: Yup.string().optional(),
    hindi: Yup.string().optional(),
  }),
});

  export default panchangDaySchema;


export const panchangDayImportSchema = Yup.object().shape({
  gregorianDate: Yup.string()
    .required("Gregorian date is required.")
    .typeError("Gregorian date must be a valid date."),
  vikramSamvatMonth: Yup.string()
    .required("Vikram Samvat month is required.")
    .oneOf(VIKRAM_SAMVAT_MONTHS, "Invalid Vikram Samvat month."),
  tithi: Yup.string().required("Tithi is required."),
  tithiNo: Yup.string()
  .test(
    "is-valid-value",
    "Invalid value. Must be a digit from 1,2,...,15,30 or a valid range like 1-2, 10-11.",
    (value) => {
      if (!value) return false;

      // Check if it's a single valid digit
      if (validTithiValues.includes(value)) {
        return true;
      }

      // Check if it's a valid range
      const rangeMatch = value.match(/^(\d+)-(\d+)$/);
      if (rangeMatch) {
        const [_, start, end] = rangeMatch;
        return validTithiValues.includes(start) && validTithiValues.includes(end);
      }

      return false;
    }
  ),
  paksha: Yup.string()
    .required("Paksha is required.")
    .oneOf(
      ["Shukla", "Krishna"],
      "Paksha must be either 'Shukla' or 'Krishna'."
    ),

  vachanamrutTithi: Yup.object().shape({
    english: Yup.string()
      .optional()
      .max(
        400,
        "Vachanamrut Tithi description must not exceed 400 characters."
      ),
    gujarati: Yup.string()
      .optional()
      .max(
        400,
        "Vachanamrut Tithi description must not exceed 400 characters."
      ),
    hindi: Yup.string()
      .optional()
      .max(
        400,
        "Vachanamrut Tithi description must not exceed 400 characters."
      ),
  }),

  swaminarayanSamvat: Yup.object().shape({
    english: Yup.string()
      .optional()
      .max(50, "Swaminarayan Samvat must not exceed 50 characters."),
    gujarati: Yup.string()
      .optional()
      .max(50, "Swaminarayan Samvat must not exceed 50 characters."),
    hindi: Yup.string()
      .optional()
      .max(50, "Swaminarayan Samvat must not exceed 50 characters."),
  }),

  dateViseVachanamrut: Yup.object().shape({
    english: Yup.string()
      .optional()
      .max(
        400,
        "Date Vise Vachanamrut Tithi description must not exceed 400 characters."
      ),
    gujarati: Yup.string()
      .optional()
      .max(
        400,
        "Date Vise Vachanamrut Tithi description must not exceed 400 characters."
      ),
    hindi: Yup.string()
      .optional()
      .max(
        400,
        "Date Vise Vachanamrut Tithi description must not exceed 400 characters."
      ),
  }),

  event: Yup.object().shape({
    english: Yup.string().optional(),
    gujarati: Yup.string().optional(),
    hindi: Yup.string().optional(),
  }),
});